import { EventSubType, EventType, MatchPhase } from '../../../../services/interfaces';

export type EventIcon = {
  icon: string;
  color?: string;
};

export const FACT_EVENT_ICONS: {
  [key in EventType]?: EventIcon & { [key in EventSubType | MatchPhase]?: EventIcon };
} = {
  [EventType.YELLOW_CARD]: {
    icon: 'football-card-single-card',
    color: 'support-05',
  },
  [EventType.RED_CARD]: {
    icon: 'football-card-single-card',
    color: 'support-04',
  },
  [EventType.RED_YELLOW_CARD]: {
    icon: 'football-card-yellow-to-red-color',
  },
  [EventType.GOAL]: {
    icon: 'football-goal',
    [EventSubType.OWN]: {
      icon: 'football-goal',
      color: 'support-04',
    },
    [EventSubType.PENALTY]: {
      icon: 'football-goal-penalty-color',
    },
    [EventSubType.MISSED]: {
      icon: 'football-goal-penalty-missed-color',
    },
    [MatchPhase.EXTRA_TIME_FIRST_HALF]: {
      icon: 'football-goal-extra-time-color',
    },
    [MatchPhase.EXTRA_TIME_SECOND_HALF]: {
      icon: 'football-goal-extra-time-color',
    },
  },
  [EventType.SUBSTITUTION]: {
    icon: 'football-substitution-both-color',
  },
  [EventType.PENALTY]: {
    icon: 'football-goal-penalty-missed-color',
    [EventSubType.SCORED]: {
      icon: 'football-goal-penalty-color',
    },
  },
  [EventType.START_PHASE]: {
    icon: 'football-time-start',
    [MatchPhase.FIRST_HALF]: {
      icon: 'football-time-wistle',
      color: 'ui-04',
    },
    [MatchPhase.PENALTY]: {
      icon: 'football-time-wistle',
    },
    [MatchPhase.EXTRA_TIME_FIRST_HALF]: {
      icon: 'football-time-extra-time-color',
    },
  },
  [EventType.END_PHASE]: {
    icon: 'football-time-end-color',
    [MatchPhase.FIRST_HALF]: {
      icon: 'football-time-extra-time-color',
    },
  },
  [EventType.PAUSE]: {
    icon: 'football-time-break',
  },
  [EventType.RESUME]: {
    icon: 'football-time-wistle',
  },
  [EventType.CHANGE_PHASE]: {
    icon: 'football-penalty-shootout',
  },
  [EventType.INJURY_TIME]: {
    icon: 'football-time-additional-time-color',
  },
  [EventType.VAR]: {
    icon: 'football-var',
  },
};
